import { render, staticRenderFns } from "./noticePage.vue?vue&type=template&id=59edc65c&scoped=true&"
import script from "./noticePage.vue?vue&type=script&lang=js&"
export * from "./noticePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59edc65c",
  null
  
)

export default component.exports